import { CategoryDocument } from 'models/category';
import { ProductDocument } from 'models/product';

export * from './products.service';

export const cleanLocation = (p: ProductDocument) => {
  if (!p) return p;
  if (p.shipment) {
    p.shipment = {
      ...p.shipment,
      ship_from: {
        address_line1: '',
        city_locality: '',
        state_province: '',
        postal_code: '',
        country_code: 'US',
        phone: '',
        is_default: false,
        name: '',
      },
    };
  }
  return {
    ...p,
    ...(p?.location && {
      location: {
        latitude: p.location.latitude ?? 0,
        longitude: p.location.longitude ?? 0,
      },
    }),
  };
};

export const DEFAULT_BREADCRUMBS = [
  {
    label: 'All',
    href: '/shop/all',
  },
];

export const formatBreadcrumbs = (
  breadcrumbs: CategoryDocument['breadcrumbs'],
  product: Pick<ProductDocument, 'ride_types'>
) => {
  const rtRemovedFromBreadcrumbs = breadcrumbs?.length
    ? breadcrumbs
        ?.slice(product.ride_types && breadcrumbs.length > 2 ? 1 : 0)
        .map((b) => ({
          label: b.name,
          href: b.slug,
        }))
    : DEFAULT_BREADCRUMBS;
  const hasMultipleRt = product.ride_types?.length > 1;
  // remove ride type from parts breadcrumbs if there are multiple ride types
  const rtRemovedFromParts =
    hasMultipleRt && rtRemovedFromBreadcrumbs[0].label.endsWith('Parts')
      ? rtRemovedFromBreadcrumbs.map((b, i) => ({
          label: i === 0 ? 'Parts' : b.label,
          href: b.href.replace(rtRemovedFromBreadcrumbs[0].href, '/shop/parts'),
        }))
      : rtRemovedFromBreadcrumbs;
  return rtRemovedFromParts;
};
